<template>
  <div class="body-card">
    <div class="image-container">
      <img
        @error="handleImageError()"
        class="image"
        :src="
          image ||
            `https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png`
        "
        alt=""
      />
    </div>
    <div class="content" style="cursor: pointer">
      <div>
        <div class="d-flex algin-items-center ">
          <img class="mr-5" :src="bg.icon_location_2" alt="" />
          <h3 class="facility-name  fw-600 c-tiny">{{ title }}</h3>
        </div>
        <div class="d-flex algin-items-center ">
          <img class="mr-5" :src="bg.icon_clock" alt="" />
          <h3 class="facility-name  c-tiny mt-2">
            Teetime {{ startTime }} - {{ endTime }}
          </h3>
        </div>
        <div class="d-flex algin-items-center ">
          <img class="mr-5" :src="bg.icon_calendar_2" alt="" />
          <h3 class="facility-name  c-tiny mt-2">
            {{ startDate }} - {{ endDate }}
          </h3>
        </div>

        <div class="price-container mb-5 m-0">
          <span class="c-text-price fw-600 c-tiny p-0 "
            >{{ formatNumber(priceDiscount) }} đ</span
          >
          <span class="price-initial p-0 text-line-through ml-5"
            >{{ formatNumber(price) }} đ</span
          >
          <span class="price-initial p-0 ml-5">(18 hole)</span>
        </div>
      </div>
      <div class="box-btn">
        <button-customer
          :styles="{
            fontSize: '12px',
            fontWeight: 500,
            height: '30px',
            width: '106px',
            padding: '5px 0px'
          }"
          :object-data="{ title: $t('wap.text146') }"
          @on-action="handleActionBooked"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency, convertDate, formatNumber } from "@/utils/formatData";
import HeartIcon from "@/assets/img/svg/heartIcon.svg";
import SaleIcon from "@/assets/img/svg/sale-icon.svg";
import { decodeToken } from "@/utils/auth";
import ButtonCustomer from "../../../components/wapV2/button/index.vue";
import { getInfo } from "@/utils/wapAuth";
import { mapGetters } from "vuex";
import { DateTime } from "luxon";
import { getBackGround } from "../../../utils/wapAuth";

export default {
  bodyClass: "card-facilities",
  components: { ButtonCustomer },
  props: {
    objectData: {
      type: Object,
      default() {
        return {};
      }
    },
    title: {
      default: ""
    },
    startTime: {
      default: ""
    },
    endTime: {
      default: ""
    },
    startDate: {
      default: ""
    },
    endDate: {
      default: ""
    },
    price: {
      default: ""
    },
    image: {
      default:
        "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png"
    },
    id: {
      default: ""
    },
    priceDiscount: {
      default: ""
    },
    facilityId: {
      default: ""
    }
  },
  watch: {
    objectData(val) {}
  },
  data() {
    return {
      bg: getBackGround(),
      type: null,
      showServiceIcon: true,
      icons: {
        HeartIcon,
        SaleIcon
      }
    };
  },
  computed: {
    ...mapGetters(["list_golfer_booking"])
  },
  methods: {
    decodeToken,
    formatCurrency,
    convertDate,
    formatNumber,
    handleImageError() {
      return "https://web-api.vcallid.com/static/uploads/03126e45-475d-4882-a01f-7a3cfaf90f3f.png";
    },
    handleActionBooked() {
      if (!getInfo()) {
        this.$store.dispatch("showLoginDialog");
        return;
      }
      const params = {
        product_id: this.objectData.id,
        flash_sale_id: this.objectData.flash_sale_id,
        price: this.priceDiscount > 0 ? this.priceDiscount : this.price,
        start_time: this.startTime,
        facility_id: this.facilityId
      };
      const query = new URLSearchParams(params).toString();
      this.$router.push(`/booking-now?${query}`);
    }
  }
};
</script>
<style></style>

<style scoped>
.box-btn {
  position: absolute;
  right: 10px;
  top: 30%;
}
.mr-10 {
  margin-right: 10px;
}

.content {
  position: relative;
  padding: 12px;
}

.full-width {
  width: 100%;
}

.price-initial {
  color: #929292;
  font-size: 10px;
}
.text-line-through {
  text-decoration: line-through;
}
.price-container {
  margin: 0;
  padding: 0;
}
.percent-text {
  position: absolute;
  top: 1px;
  left: 5px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}
.facility-title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.icon-sale-container {
  position: absolute;
  top: 10px;
}
.icon-heart-container {
  position: absolute;
  top: 10px;
  right: 10px;
}
.image-container {
  position: relative;
  overflow: hidden;
  height: 127px;
}
.body-card {
  background-color: #fff;

  position: relative;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 20px;
  min-height: 220px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
}
.image {
  user-drag: none; /* Safari */
  -webkit-user-drag: none; /* Chrome, Safari, Edge */
  -moz-user-select: none; /* Firefox */
  user-select: none; /* Ngăn chọn ảnh */
  pointer-events: auto; /* Vẫn cho click */
  width: 100% !important;
  height: 127px !important;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  object-fit: cover;
  object-position: top;
}
.text-left {
  width: 100%;
  text-align: left;
}

.mb-0 {
  margin-bottom: 0;
}
.facility-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}
@media screen and (min-width: 0px) and (max-width: 550px) {
  .body-card {
    position: relative;
    overflow: hidden;
    border-radius: 6px;
    margin-bottom: 15px;
    width: 220px;
    box-shadow: 0px 0px 4px 0px #00000026;
  }
}
</style>
